import { useQuery } from "@tanstack/react-query";
import { salvcarService } from "../services/salvcarService";
import {
  ContextItem,
  ContextParams,
} from "../services/salvcarService/getContext";

export const useContextSalvcar = (params?: ContextParams) => {
  const enabled = !!params && !!params.type;

  const { data, isLoading, isFetching, isSuccess, isError, error } = useQuery<
    ContextItem[]
  >({
    queryKey: ["contextData", params],
    queryFn: () => salvcarService.getContext(params!),
    enabled,
  });

  return {
    data,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
  };
};
